<template>
  <div class="contractors-modal-general-table__row">
    <div
      class="contractors-modal-general-table__cell"
      :class="{ 'contractors-modal-general-table__cell_error': rowErrors.name }"
    >
      <InfoTooltip bottom>
        <template #element>
          <input
            autocomplete="chrome-off"
            :value="contact.name"
            @input="$emit('input', { value: $event.target.value, key: 'name' })"
          />
        </template>
        <template v-if="rowErrors.name" #default>
          <span>{{ getErrorsByField('name') }}</span>
        </template>
      </InfoTooltip>
    </div>
    <div
      class="contractors-modal-general-table__cell"
      :class="{ 'contractors-modal-general-table__cell_error': showEmailError }"
    >
      <InfoTooltip bottom>
        <template #element>
          <input
            autocomplete="chrome-off"
            :value="contact.email"
            @input="$emit('input', { value: $event.target.value, key: 'email' })"
          />
        </template>
        <template v-if="rowErrors.email" #default>
          <span>{{ getErrorsByField('email') }}</span>
        </template>
      </InfoTooltip>
    </div>
    <div
      class="contractors-modal-general-table__cell"
      :class="{
        'contractors-modal-general-table__cell_error': showPhoneError,
      }"
    >
      <InfoTooltip bottom>
        <template #element>
          <input
            autocomplete="chrome-off"
            type="text"
            :value="contact.phone_number"
            @input="$emit('input', { value: $event.target.value, key: 'phone_number' })"
          />
        </template>
        <template v-if="rowErrors.phone_number" #default>
          <span>{{ getErrorsByField('phone_number') }}</span>
        </template>
      </InfoTooltip>
    </div>
    <div
      class="contractors-modal-general-table__cell"
      :class="{ 'contractors-modal-general-table__cell_error': rowErrors.position }"
    >
      <InfoTooltip bottom>
        <template #element>
          <input
            autocomplete="chrome-off"
            :value="contact.position"
            @input="$emit('input', { value: $event.target.value, key: 'position' })"
          />
        </template>
        <template v-if="rowErrors.position" #default>
          <span>{{ getErrorsByField('position') }}</span>
        </template>
      </InfoTooltip>
    </div>
    <div
      class="contractors-modal-general-table__cell contractors-modal-general-table__cell_centering"
    >
      <Icon
        type="x"
        color="secondary"
        size="16"
        class="pointer"
        @click.native="removeContactHandler"
      />
    </div>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';
  import InfoTooltip from '@/components/ui/InfoTooltip';
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'ContractorsModalGeneralTableRow',
    components: { Icon, InfoTooltip },
    props: {
      contact: {
        type: Object,
        required: true,
      },
      rowErrors: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      ...mapState('contractors', ['errors']),
      showPhoneError() {
        return (
          this.rowErrors.phone_number ||
          this.errors?.doubling_phone_numbers?.includes(this.contact.phone_number)
        );
      },
      showEmailError() {
        return this.rowErrors.email || this.errors?.doubling_emails?.includes(this.contact.email);
      },
    },
    methods: {
      ...mapActions({
        confirm: 'confirmModal/openModal',
      }),
      getErrorsByField(field) {
        return this.rowErrors[field]?.join(' ');
      },
      removeContactHandler() {
        this.confirm({
          title: this.$t('Delete this contact'),
          description: this.$t(
            'The contact will be permanently deleted and you will not be able to recover it.'
          ),
          cancelText: this.$t('Cancel'),
          actionText: this.$t('Delete'),
          action: () => this.$emit('remove-contact-row'),
        });
      },
    },
  };
</script>
